import { Button } from "@chakra-ui/react"
import { colors } from "../../utilities/colors"
import Spinner from "./Spinner"

export function HappyButton({ text, onClick, style = "", loading=null }) {
  return(
    <div className="flex">
      <Button
        onClick={onClick}
        variant="outline"
        borderColor={colors.green}
        borderWidth="2px"
        borderRadius="full"
        px={8}
        py={1.5}
        w="full"
        _hover={{ opacity: 0.75, cursor: "pointer" }}
        className={style}
        textColor={colors.grey100}
      >
        {loading ?
          <Spinner color={"grey-100"} height={'25px'}/>
          :
          text
        }
      </Button>
    </div>
  )
}

export function NeutralButton({ text, onClick, style = "", dataTestId=null, loading=null, disabled=null }) {
  return(
    <div className="flex" data-testid={dataTestId}>
      <Button
      onClick={onClick}
      variant="outline"
      borderColor={colors.grey100}
      borderWidth="2px"
      borderRadius="full"
      px={8}
      py={1.5}
      w="full"
      _hover={{ opacity: 0.75, cursor: "pointer" }}
      className={style}
      textColor={colors.grey100}
      disabled={disabled}
      >
        {loading ?
          <Spinner color={"grey-100"} height={'25px'}/>
          :
          text
        }
      </Button>
    </div>
  )
}

export function RedButton({ text, onClick, style = "" }) {
  return(
    <div className="flex">
      <Button
      onClick={onClick}
      variant="outline"
      borderColor={colors.fpxRed}
      borderWidth="2px"
      borderRadius="full"
      px={8}
      py={1.5}
      w="full"
      _hover={{ opacity: 0.75, cursor: "pointer" }}
      className={style}
      textColor={colors.grey100}
      >
        {text}
      </Button>
    </div>
  )
}

export function SolidGreenButton({ text, onClick, style = "" }) {
  return(
    <Button
      onClick={onClick}
      className={style}
      bg={colors.green}
      color={colors.grey100}
      _hover={{ opacity: 0.75 }}
      py={1.5}
      px={8}
      border="2px"
      borderColor={colors.green}
      borderRadius="full"
    >
      {text}
    </Button>
  )
}